export default class t {
  constructor() {}
  U(a) {}
  changeUser(a = !1) {}
  clearData(a = !1) {}
}
